__turbopack_context__.v({
  "branch_carousel": "BranchList-module-scss-module__MweXnG__branch_carousel",
  "branch_carousel_swiper": "BranchList-module-scss-module__MweXnG__branch_carousel_swiper",
  "branch_carousel_swiper--compact": "BranchList-module-scss-module__MweXnG__branch_carousel_swiper--compact",
  "branch_header": "BranchList-module-scss-module__MweXnG__branch_header",
  "branch_more": "BranchList-module-scss-module__MweXnG__branch_more",
  "branch_title": "BranchList-module-scss-module__MweXnG__branch_title",
});
